import { useMutation } from "@tanstack/react-query"
import fetchData from "../fetcher"

export const useLogout = () => {
    const { mutateAsync: Logout, data, error, isError, isPending } = useMutation({
        mutationFn: () => fetchData('/iam/v4/auth/logout'),
    })

    return { Logout, data, error, isError, isPending }
}